import {UserModel} from "../../shared/models/user/user.model";

export class LoginModel extends UserModel {
    public serialize() {
        return {
            email: this.email,
            password: this.password,
        };
    }
}


// WEBPACK FOOTER //
// /code/frontend/src/app/auth/login/login.model.ts